<template>
  <div>
    <div class="hvh-flex align-center mb-3">
      <v-icon @click="isExpanded = true" v-if="!isExpanded">mdi-plus-box-outline</v-icon>
      <v-icon @click="isExpanded = false" v-else>mdi-minus-box-outline</v-icon>
      <CheckBox class="ml-2" :value="isAllSelected" :half="!isAllSelected && isAnySelected" @input="toggleAll" />
      <span class="clickable no-wrap ml-3" @click="toggleAll">{{ itemLabelFnc(group).toUpperCase() }}</span>
    </div>
    <div v-if="isExpanded">
      <div class="hvh-flex aling-center mb-3 pr-5 pl-4" v-for="(child, ind) in group.children" :key="ind">
        <CheckBox class="ml-2" :value="selected[itemValueFnc(child)]" @input="emitData(itemValueFnc(child))" />
        <span style="max-width: 400px" class="clickable no-wrap ml-3" @click="emitData(itemValueFnc(child))">{{ itemLabelFnc(child) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { propToFnc } from '../../../../libraries/common';
import CheckBox from '../../../common/form/checkbox/CheckBox.vue';
export default {
  components: { CheckBox },
  props: ['group', 'value', 'itemLabel', 'itemValue'],
  data() {
    return { isExpanded: false };
  },
  computed: {
    ids() {
      return this.group.children
        .reduce((acc, f) => { acc[this.itemValueFnc(f)] = true; return acc; }, {});
    },
    selected() {
      return (this.value || [])
        .reduce((acc, f) => {
          if (this.ids[f]) acc[f] = true;
          return acc;
        }, {});
    },
    isAllSelected() {
      return this.group.children.all(f => this.selected[this.itemValueFnc(f)]);
    },
    isAnySelected() {
      return this.group.children.any(f => this.selected[this.itemValueFnc(f)]);
    },
    itemLabelFnc() {
      return propToFnc(this.itemLabel);
    },
    itemValueFnc() {
      return propToFnc(this.itemValue);
    },
  },
  methods: {
    toggleAll() {
      var shouldCheck = !this.isAnySelected;
      var filteredValue = (this.value || []).filter(f => !this.ids[f]);
      this.$emit('input', filteredValue.concat(shouldCheck ? this.group.children.map(this.itemValueFnc) : []));
    },
    emitData(event) {
      if (this.selected[event])
        this.$emit('input', (this.value || []).filter(f => f !== event));
      else
        this.$emit('input', [...(this.value || []), event]);
    },
  },
}
</script>